import { HTMLAttributes, forwardRef, ReactNode } from 'react';

import { cn } from '../utils/cn';

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  variant?: 'default' | 'card';
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, variant = 'default', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col items-center justify-center text-center py-12 px-6',
        {
          'rounded-[var(--ids-radius-lg,14px)] border border-dashed border-[color:var(--ids-border-strong,rgba(255,255,255,0.14))]':
            variant === 'card',
        },
        className
      )}
      {...props}
    >
      {icon && (
        <div className="w-16 h-16 mb-4 flex items-center justify-center rounded-full bg-[color:var(--ids-bg-subtle,#0F1626)] text-[color:var(--ids-text-muted,#94A3B8)]">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-semibold text-[color:var(--ids-text,#F8FAFC)] mb-1">{title}</h3>
      {description && (
        <p className="text-sm text-[color:var(--ids-text-muted,#94A3B8)] max-w-sm mb-4">
          {description}
        </p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
);

EmptyState.displayName = 'EmptyState';
